var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2117_8503)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 16.2073C13.0208 16.3948 12.7665 16.5001 12.5013 16.5001C12.2362 16.5001 11.9818 16.3948 11.7943 16.2073L6.13732 10.5503C6.04181 10.4581 5.96563 10.3478 5.91322 10.2257C5.86081 10.1037 5.83322 9.97252 5.83207 9.83974C5.83092 9.70696 5.85622 9.57529 5.9065 9.45239C5.95678 9.32949 6.03103 9.21784 6.12492 9.12395C6.21882 9.03006 6.33047 8.9558 6.45337 8.90552C6.57626 8.85524 6.70794 8.82994 6.84072 8.83109C6.9735 8.83225 7.10472 8.85983 7.22672 8.91224C7.34873 8.96465 7.45907 9.04083 7.55132 9.13634L12.5013 14.0863L17.4513 9.13634C17.6399 8.95418 17.8925 8.85339 18.1547 8.85567C18.4169 8.85795 18.6677 8.96312 18.8531 9.14852C19.0385 9.33393 19.1437 9.58474 19.146 9.84694C19.1483 10.1091 19.0475 10.3617 18.8653 10.5503L13.2083 16.2073Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2117_8503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.d730749d459eac9aeba329f2ee9b5d5d.svg";
export { ForwardRef as ReactComponent };